/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const MatchedTokenResponseFragment = `
    fragment MatchedTokenResponseFragment on MatchedTokenResponse {
  access_token
  id_token
  token_type
  expires_in
}
    `
export const ExternalResponseFragment = `
    fragment ExternalResponseFragment on ExternalResponse {
  success
  message
}
    `
export const ValidateCaptchaAndMatchDocument = `
    mutation validateCaptchaAndMatch($input: ValidateCaptchaAndMatchInput!) {
  validateCaptchaAndMatch(input: $input) {
    ...MatchedTokenResponseFragment
  }
}
    ${MatchedTokenResponseFragment}`
export const SendOtpDocument = `
    mutation sendOTP($input: SendOTPInput!) {
  sendOTP(input: $input) {
    ...ExternalResponseFragment
  }
}
    ${ExternalResponseFragment}`
export const ConfirmOtpAndMatchDocument = `
    mutation confirmOTPAndMatch($input: ConfirmOTPAndMatchInput!) {
  confirmOTPAndMatch(input: $input) {
    ...MatchedTokenResponseFragment
  }
}
    ${MatchedTokenResponseFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    validateCaptchaAndMatch: build.mutation<
      Types.ValidateCaptchaAndMatch,
      Types.ValidateCaptchaAndMatchVariables
    >({
      query: (variables) => ({
        document: ValidateCaptchaAndMatchDocument,
        variables,
      }),
    }),
    sendOTP: build.mutation<Types.SendOtp, Types.SendOtpVariables>({
      query: (variables) => ({ document: SendOtpDocument, variables }),
    }),
    confirmOTPAndMatch: build.mutation<
      Types.ConfirmOtpAndMatch,
      Types.ConfirmOtpAndMatchVariables
    >({
      query: (variables) => ({
        document: ConfirmOtpAndMatchDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
